/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
import {Injectable} from '@angular/core';
import {AlertModalService} from '../../../../common/component/modal';
import {AppConfigService} from '../../../../common/service/app-config.service';
import {AngleUtilService} from '../../../services/features/angle/angle-util.service';
import {AnnotationService} from '../../../services/features/annotation.service';
import {EnlargementUtilService} from './enlargement-util.service';
import {FeaturesAdjustmentService} from '../../../services/features-adjustment.service';
import {FeaturesApplyInsertService} from '../../../services/features-apply-insert.service';
import {FeatureApplyUpdateService} from '../../../services/feature-apply-update.service';
import {AnnotationUtilityService} from '../../../services/features/annotation-utility.service';
import {LabelExpressionService} from '../../../services/label-expression/label-expression.service';
import {MapService} from '../../../services/map.service';
import {SpatialSequenceService} from '../../../../common/service/spatial-sequence.service';
import {FeaturesAdjustmentUtilService} from '../../../services/features-adjustment-util.service';
import {LookupService} from '../../../../common/service/lookup.service';
import {PlanModelService} from '../../../../common/service/plan-model.service';
import {PrintAreaService} from '../../../../common/service/print-area.service';
import {SpatialUtilService} from '../../../services/spatial-util.service';
import {MapModeService} from '../../../services/map-mode.service';
import {EsriModuleService} from '../../../esri-nlr/services/esri-module.service';
import {NgEventBus} from 'ng-event-bus';
import {interval, Observable, of, Subscription, take} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EnlargementCreateService {
    private readyToBroadcastInterval: Subscription;
    constructor(
        private alertModalService: AlertModalService,
        private appConfigService: AppConfigService,
        private angleUtilService: AngleUtilService,
        private annotationService: AnnotationService,
        private enlargementUtilService: EnlargementUtilService,
        private featuresAdjustmentService: FeaturesAdjustmentService,
        private featuresApplyInsertService: FeaturesApplyInsertService,
        private featuresApplyUpdateService: FeatureApplyUpdateService,
        private annotationUtilService: AnnotationUtilityService,
        private labelExpressionService: LabelExpressionService,
        private mapService: MapService,
        private spatialSequenceService: SpatialSequenceService,
        private featuresAdjustmentUtilService: FeaturesAdjustmentUtilService,
        private lookupService: LookupService,
        private planModelService: PlanModelService,
        private printAreaService: PrintAreaService,
        private spatialUtilService: SpatialUtilService,
        private mapModeService: MapModeService,
        private esriModuleService: EsriModuleService,
        private eventBus: NgEventBus
    ) {}

    title = 'EnlargementCreateService';

    private getInterestPolylineTotalLotBoundaryLineTypeLookups() {
        return this.lookupService.getLookups('lineType').filter(l => ['InterestPolyline', 'TotalLotBoundary'].includes(l.businessClass));
    }

    createEnlargement(attributes: any, graphic: any, callback: any) {
        console.debug(this.title + ' createPolygon');

        const annotationsWithinExisting = [];
        const annotationsWithinEnlargement = [];
        const anglesWithinExisting = [];
        const anglesWithinEnlargement = [];

        const polygonAttributes = {
            id: undefined
        };

        Object.keys(attributes).forEach(key => {
            const attribute = attributes[key];
            if (typeof attribute === 'object') {
                if (attribute['referenceScale']) {
                    const value = attribute['referenceScale'].split(':');
                    polygonAttributes[key] = value.length > 0 ? value[1] : value[0];
                } else if (attribute['description']) {
                    polygonAttributes[key] = attribute['description'];
                } else {
                    polygonAttributes[key] = attribute.id;
                }
            } else {
                polygonAttributes[key] = attribute;
            }
        });

        polygonAttributes['guid'] = this.planModelService.getGuid();
        polygonAttributes['type'] = '1';

        this.enlargementUtilService.findRelatedFeatures(
            this.spatialUtilService.getAnnotationMapLayer(),
            graphic.geometry.getExtent(),
            undefined,
            [
                this.spatialUtilService.getLineMapLayer(),
                this.spatialUtilService.getPolylineMapLayer(),
                this.spatialUtilService.getPolygonMapLayer(),
                this.spatialUtilService.getLotMapLayer(),
                this.spatialUtilService.getInterestMapLayer(),
                this.spatialUtilService.getConstructLineMapLayer()
            ],
            annotationsWithinExisting,
            annotationsWithinEnlargement,
            () => {
                const enlargementId = this.spatialSequenceService.getEnlargementSequence(1)[0];

                this.enlargementUtilService.findAllAnnotationsWithinPolygon(
                    graphic.geometry,
                    annotationsWithinExisting,
                    annotationsWithinEnlargement,
                    () => {
                        this.enlargementUtilService.findAllAnglesForEnlargementCreation(
                            graphic.geometry,
                            anglesWithinExisting,
                            anglesWithinEnlargement
                        );
                        this.addSelectedAnnotations(annotationsWithinExisting, annotationsWithinEnlargement);
                        this.addSelectedAngles(anglesWithinExisting, anglesWithinEnlargement);

                        let existingAnnotationsUpdatedCheck = annotationsWithinExisting.length === 0;
                        let existingAnglesUpdatedCheck = anglesWithinExisting.length === 0;

                        const mainMapScale = this.printAreaService.getReferenceScaleDivisor();
                        const enlargementScale = attributes.scale['referenceScale'].split(':');
                        const scaleRatio = (enlargementScale.length > 1 ? enlargementScale[1] : enlargementScale[0]) / mainMapScale;

                        const polygonGraphic = new this.esriModuleService.Graphic(graphic.geometry);
                        polygonAttributes.id = enlargementId;
                        polygonGraphic.attributes = polygonAttributes;

                        this.createEnlargementFeature(polygonGraphic, enlargementFeature => {
                            if (callback) {
                                callback(enlargementFeature.attributes.id);
                            }

                            if (anglesWithinExisting.length === 0 && annotationsWithinExisting.length === 0) {
                                this.eventBus.cast('changeMapMode', enlargementFeature.attributes.id);
                            } else if (anglesWithinExisting.length > 0 && annotationsWithinExisting.length > 0) {
                                this.readyToBroadcastInterval = interval(1000)
                                    .pipe(take(60))
                                    .subscribe(() => {
                                        if (existingAnglesUpdatedCheck && existingAnnotationsUpdatedCheck) {
                                            this.readyToBroadcastInterval.unsubscribe();
                                            this.eventBus.cast('changeMapMode', enlargementFeature.attributes.id);
                                        }
                                    });
                            } else if (anglesWithinExisting.length > 0 && annotationsWithinExisting.length === 0) {
                                this.readyToBroadcastInterval = interval(900)
                                    .pipe(take(5)) // Limits to 5 iterations
                                    .subscribe(() => {
                                        if (existingAnglesUpdatedCheck) {
                                            this.readyToBroadcastInterval.unsubscribe();
                                            this.eventBus.cast('changeMapMode', enlargementFeature.attributes.id);
                                        }
                                    });
                            } else if (anglesWithinExisting.length === 0 && annotationsWithinExisting.length > 0) {
                                this.readyToBroadcastInterval = interval(900)
                                    .pipe(take(5))
                                    .subscribe(() => {
                                        if (existingAnnotationsUpdatedCheck) {
                                            this.readyToBroadcastInterval.unsubscribe();
                                            this.eventBus.cast('changeMapMode', enlargementFeature.attributes.id);
                                        }
                                    });
                            }
                        });

                        if (annotationsWithinExisting.length > 0) {
                            this.enlargementUtilService.updateEnlargementId(enlargementId, annotationsWithinExisting);
                            this.updateFeatures(this.spatialUtilService.getAnnotationMapLayer(), annotationsWithinExisting, () => {
                                existingAnnotationsUpdatedCheck = true;
                            });
                        }

                        const geometryService = new this.esriModuleService.GeometryService(
                            this.appConfigService.getDesignProperties().GEOMETRY_SERVER_URL
                        );

                        geometryService.labelPoints([graphic.geometry], labelPoints => {
                            const point = new this.esriModuleService.Point(labelPoints[0].x, labelPoints[0].y);
                            point.setSpatialReference(graphic.geometry.spatialReference);
                            const enlargementAnnotationGraphic = new this.esriModuleService.Graphic(point);

                            enlargementAnnotationGraphic.attributes = {};
                            enlargementAnnotationGraphic.attributes.id = enlargementId;
                            enlargementAnnotationGraphic.attributes.featureid = enlargementId;
                            enlargementAnnotationGraphic.attributes.guid = this.planModelService.getGuid();
                            enlargementAnnotationGraphic.attributes.attribute1 = attributes['name'];
                            enlargementAnnotationGraphic.attributes.featuretype = 'enlargement';
                            enlargementAnnotationGraphic.attributes.featuresubtype = 1;
                            enlargementAnnotationGraphic.attributes.x = labelPoints[0].x;
                            enlargementAnnotationGraphic.attributes.y = labelPoints[0].y;

                            enlargementAnnotationGraphic.attributes.labelexpression = this.labelExpressionService.create(
                                enlargementAnnotationGraphic.attributes
                            );

                            enlargementAnnotationGraphic.attributes.visible = 'YES';
                            enlargementAnnotationGraphic.attributes.rotationdms = '90:00:00';
                            enlargementAnnotationGraphic.attributes.rotation = 90;

                            annotationsWithinEnlargement.push(enlargementAnnotationGraphic);

                            const annotationIds = this.spatialSequenceService.getAnnotationSequence(annotationsWithinEnlargement.length);
                            this.createFeatures(
                                enlargementId,
                                annotationIds,
                                this.spatialUtilService.getAnnotationMapLayer(),
                                annotationsWithinEnlargement,
                                polygonAttributes['scale'],
                                scaleRatio
                            );
                        });

                        if (anglesWithinExisting.length > 0) {
                            this.enlargementUtilService.updateEnlargementId(enlargementId, anglesWithinExisting);
                            this.updateFeatures(this.spatialUtilService.getAngleMapLayer(), anglesWithinExisting, () => {
                                existingAnglesUpdatedCheck = true;
                            });
                        }

                        if (anglesWithinEnlargement.length > 0) {
                            const angleIds = this.spatialSequenceService.getAngleSequence(anglesWithinEnlargement.length);
                            this.createFeatures(
                                enlargementId,
                                angleIds,
                                this.spatialUtilService.getAngleMapLayer(),
                                anglesWithinEnlargement,
                                polygonAttributes['scale'],
                                scaleRatio
                            );
                        }
                    }
                );
            }
        );
    }

    applyEnlargementRecreation(
        enlargementFeature: any,
        annotationsEnlargement: any[],
        annotationsExisting: any[],
        anglesEnlargement: any[],
        anglesExisting: any[],
        refScaleItem: number,
        lineTypeLookups: any,
        annotationsBeforeChange: any[],
        anglesBeforeChange: any[],
        ignoreMapUpdate: boolean
    ) {
        const deltaAnnotationsCreate = [];
        const deltaAnnotationsUpdate = [];
        const deltaAnnotationsDelete = [];

        const mainAnnotationsRemoveId = [];
        const mainAnnotationsAddId = [];

        const deltaAnglesCreate = [];
        const deltaAnglesUpdate = [];
        const deltaAnglesDelete = [];

        const mainAnglesRemoveId = [];
        const mainAnglesAddId = [];

        const enlargementScaleRatio = refScaleItem / enlargementFeature.attributes.scale;

        const mainMapScaleRatio = refScaleItem / this.printAreaService.getReferenceScaleDivisor();

        annotationsEnlargement
            .filter(annotation => annotation.attributes.featuretype !== 'enlargement')
            .forEach(annotation => {
                const annotationBeforeChange = annotationsBeforeChange.find(a => a.attributes.parentid === annotation.attributes.parentid);
                if (annotationBeforeChange) {
                    annotation.attributes.id = annotationBeforeChange.attributes.id;

                    switch (annotation.attributes.featuretype) {
                        case 'lot':
                        case 'road':
                            this.featuresAdjustmentUtilService.adjustLotOrRoadFeatures([annotation], refScaleItem, enlargementScaleRatio);
                            break;
                        default:
                            deltaAnnotationsUpdate.push(
                                this.adjustFeature(
                                    this.spatialUtilService.getAnnotationMapLayer(),
                                    annotation,
                                    refScaleItem,
                                    lineTypeLookups,
                                    enlargementScaleRatio
                                )
                            );
                            break;
                    }
                } else if (annotation.attributes.labelexpression) {
                    // Existing empty annotations are not rendered but should not be recreated
                    deltaAnnotationsCreate.push(
                        this.adjustFeature(
                            this.spatialUtilService.getAnnotationMapLayer(),
                            annotation,
                            refScaleItem,
                            lineTypeLookups,
                            mainMapScaleRatio
                        )
                    );

                    mainAnnotationsAddId.push(...annotationsExisting.filter(a => a.attributes.id === annotation.attributes.parentid));
                }
            });

        const mainAnnotations = this.spatialUtilService.getAnnotations().filter(a => !a.attributes.enlargementid && !a.attributes.parentid);

        annotationsBeforeChange
            .filter(a => a.attributes.featuretype !== 'enlargement')
            .forEach(item => {
                const itemIds = [item.attributes.id, item.attributes.parentid].filter(id => id);

                if (!annotationsEnlargement.some(v => itemIds.includes(v.attributes.id) || itemIds.includes(v.attributes.parentid))) {
                    deltaAnnotationsDelete.push(item);

                    mainAnnotationsRemoveId.push(
                        ...mainAnnotations.filter(mainAnnotation => mainAnnotation.attributes.id === item.attributes.parentid)
                    );
                }
            });

        anglesEnlargement
            .filter(a => a.attributes.internalangle)
            .forEach(angle => {
                const angleBeforeChange = anglesBeforeChange.find(a => a.attributes.parentid === angle.attributes.parentid);

                if (angleBeforeChange) {
                    angle.attributes.id = angleBeforeChange.attributes.id;
                    angle.attributes.enlargementid = angleBeforeChange.attributes.enlargementid;
                    deltaAnglesUpdate.push(angle);
                    // eslint-disable-next-line max-len
                    //deltaAnglesCreate.push(this.adjustFeature(this.spatialUtilService.getAngleMapLayer(), angle, refScaleItem, lineTypeLookups, mainMapScaleRatio));
                } else {
                    deltaAnglesCreate.push(
                        this.adjustFeature(this.spatialUtilService.getAngleMapLayer(), angle, refScaleItem, lineTypeLookups, mainMapScaleRatio)
                    );

                    mainAnglesAddId.push(...anglesExisting.filter(a => a.attributes.id === angle.attributes.parentid));
                }
            });

        const mainAngles = this.spatialUtilService.getAngles().filter(a => !a.attributes.enlargementid && !a.attributes.parentid);

        anglesBeforeChange.forEach(item => {
            const itemIds = [item.attributes.id, item.attributes.parentid].filter(id => id);

            if (!anglesEnlargement.some(v => itemIds.includes(v.attributes.id) || itemIds.includes(v.attributes.parentid))) {
                deltaAnglesDelete.push(item);

                mainAnglesRemoveId.push(...mainAngles.filter(mainAngle => mainAngle.attributes.id === item.attributes.parentid));
            }
        });

        if (deltaAnnotationsUpdate.length > 0) {
            this.spatialUtilService
                .applyEdits('annotation', null, deltaAnnotationsUpdate, null)
                .pipe(take(1))
                .subscribe({
                    next: res => {
                        console.debug(this.title + ' : updateAnnotations - updates - RESULT: ' + JSON.stringify(res));

                        if (res.updates[0].success) {
                            console.debug(this.title + ' : updateAnnotations - annotations updated successfully');
                        } else {
                            const errorMessage =
                                res.updates[0].error && res.updates[0].error.message ? ' Error : ' + res.updates[0].error.message : '';
                            this.alertModalService.createAlertMessage('Error updating annotation features.' + errorMessage, 'Ok');
                        }
                    },
                    error: err => {
                        this.alertModalService.createAlertMessage('Error updating annotation features. Error : ' + err, 'Ok');
                    }
                });
        }

        if (deltaAnnotationsDelete.length > 0) {
            this.spatialUtilService
                .applyEdits('annotation', null, null, deltaAnnotationsDelete)
                .pipe(take(1))
                .subscribe({
                    next: res => {
                        console.debug(this.title + ' : deletedAnnotations - delete - RESULT: ' + JSON.stringify(res.deletes));
                        if (res.deletes.length) {
                            if (res.deletes[0].success) {
                                console.debug(this.title + ' : deleteAnnotations - annotations updated successfully');
                            } else {
                                const errorMessage =
                                    res.updates[0].error && res.updates[0].error.message ? ' Error : ' + res.updates[0].error.message : '';
                                this.alertModalService.createAlertMessage('Error deleting annotation features.' + errorMessage, 'Ok');
                            }
                        }
                    },
                    error: err => {
                        this.alertModalService.createAlertMessage('Error deleting annotations features. Error : ' + err, 'Ok');
                    }
                });
        }

        if (deltaAnglesUpdate.length > 0) {
            this.spatialUtilService
                .applyEdits('angle', null, deltaAnglesUpdate, null)
                .pipe(take(1))
                .subscribe({
                    next: res => {
                        console.debug(this.title + ' : updateAngles - updates - RESULT: ' + JSON.stringify(res.updates));

                        if (res.updates[0].success) {
                            console.debug(this.title + ' : updateAngles - angles updated successfully');
                        } else {
                            const errorMessage =
                                res.updates[0].error && res.updates[0].error.message ? ' Error : ' + res.updates[0].error.message : '';
                            this.alertModalService.createAlertMessage('Error updating angles features.' + errorMessage, 'Ok');
                        }
                    },
                    error: err => {
                        this.alertModalService.createAlertMessage('Error updating angles features. Error : ' + err, 'Ok');
                    }
                });
        }

        if (deltaAnglesDelete.length > 0) {
            this.spatialUtilService
                .applyEdits('angle', null, null, deltaAnglesDelete)
                .pipe(take(1))
                .subscribe({
                    next: res => {
                        console.debug(this.title + ' : deletedAngles - delete - RESULT: ' + JSON.stringify(res.deletes));

                        if (res.deletes.length) {
                            if (res.deletes[0].success) {
                                console.debug(this.title + ' : deleteAngles - angles updated successfully');
                            } else {
                                const errorMessage =
                                    res.updates[0].error && res.updates[0].error.message ? ' Error : ' + res.updates[0].error.message : '';
                                this.alertModalService.createAlertMessage('Error deleting angles features.' + errorMessage, 'Ok');
                            }
                        }
                    },
                    error: err => {
                        this.alertModalService.createAlertMessage('Error deleting angles features. Error : ' + err, 'Ok');
                    }
                });
        }

        if (deltaAnnotationsCreate.length > 0) {
            const annotationIds = this.spatialSequenceService.getAnnotationSequence(deltaAnnotationsCreate.length);
            this.createFeatures(
                enlargementFeature.attributes.id,
                annotationIds,
                this.spatialUtilService.getAnnotationMapLayer(),
                deltaAnnotationsCreate,
                enlargementFeature.attributes.scale,
                1
            );
        }

        if (deltaAnglesCreate.length > 0) {
            const angleIds = this.spatialSequenceService.getAngleSequence(deltaAnglesCreate.length);
            this.createFeatures(
                enlargementFeature.attributes.id,
                angleIds,
                this.spatialUtilService.getAngleMapLayer(),
                deltaAnglesCreate,
                enlargementFeature.attributes.scale,
                1
            );
        }

        if (!(ignoreMapUpdate && ignoreMapUpdate === true)) {
            this.mapService.map.removeLayer(this.mapService.mapServiceLayer);
            this.mapService.addMapServiceLayer(refScaleItem, false, 1);
            this.mapModeService.updateEnlargementScaleInList(enlargementFeature);
        }

        if (mainAnnotationsRemoveId.length > 0) {
            this.enlargementUtilService.updateEnlargementIdFromFeatures(enlargementFeature.attributes.id, mainAnnotationsRemoveId);
            this.spatialUtilService
                .applyEdits('annotation', null, mainAnnotationsRemoveId, null)
                .pipe(take(1))
                .subscribe({
                    next: res => {
                        console.debug(this.title + ' : updateAnnotations - updates - RESULT: ' + JSON.stringify(res.updates));

                        if (res.updates[0].success) {
                            console.debug(this.title + ' : updateAnnotations - annotations updated successfully');
                        } else {
                            const errorMessage =
                                res.updates[0].error && res.updates[0].error.message ? ' Error : ' + res.updates[0].error.message : '';
                            this.alertModalService.createAlertMessage('Error updating annotation features.' + errorMessage, 'Ok');
                        }
                    },
                    error: err => {
                        this.alertModalService.createAlertMessage('Error updating annotation features. Error : ' + err, 'Ok');
                    }
                });
        }

        if (mainAnnotationsAddId.length > 0) {
            this.enlargementUtilService.updateEnlargementId(enlargementFeature.attributes.id, mainAnnotationsAddId);

            this.spatialUtilService
                .applyEdits('annotation', null, mainAnnotationsAddId, null)
                .pipe(take(1))
                .subscribe({
                    next: res => {
                        console.debug(this.title + ' : updateAnnotations - updates - RESULT: ' + JSON.stringify(res.updates));

                        if (res.updates[0].success) {
                            console.debug(this.title + ' : updateAnnotations - annotations updated successfully');
                        } else {
                            const errorMessage =
                                res.updates[0].error && res.updates[0].error.message ? ' Error : ' + res.updates[0].error.message : '';
                            this.alertModalService.createAlertMessage('Error updating annotation features.' + errorMessage, 'Ok');
                        }
                    },
                    error: err => {
                        this.alertModalService.createAlertMessage('Error updating annotation features. Error : ' + err, 'Ok');
                    }
                });
        }

        if (mainAnglesRemoveId.length > 0) {
            this.enlargementUtilService.updateEnlargementIdFromFeatures(enlargementFeature.attributes.id, mainAnglesRemoveId);
            this.spatialUtilService
                .applyEdits('angle', null, mainAnglesRemoveId, null)
                .pipe(take(1))
                .subscribe({
                    next: res => {
                        console.debug(this.title + ' : updateAngles - updates - RESULT: ' + JSON.stringify(res.updates));

                        if (res.updates[0].success) {
                            console.debug(this.title + ' : updateAngles - angles updated successfully');
                        } else {
                            const errorMessage =
                                res.updates[0].error && res.updates[0].error.message ? ' Error : ' + res.updates[0].error.message : '';
                            this.alertModalService.createAlertMessage('Error updating angles features.' + errorMessage, 'Ok');
                        }
                    },
                    error: err => {
                        this.alertModalService.createAlertMessage('Error updating angles features. Error : ' + err, 'Ok');
                    }
                });
        }

        if (mainAnglesAddId.length > 0) {
            this.enlargementUtilService.updateEnlargementId(enlargementFeature.attributes.id, mainAnglesAddId);

            this.spatialUtilService
                .applyEdits('angle', null, mainAnglesAddId, null)
                .pipe(take(1))
                .subscribe({
                    next: res => {
                        console.debug(this.title + ' : updateAngles - updates - RESULT: ' + JSON.stringify(res.updates));

                        if (res.updates[0].success) {
                            console.debug(this.title + ' : updateAngles - angles updated successfully');
                        } else {
                            const errorMessage =
                                res.updates[0].error && res.updates[0].error.message ? ' Error : ' + res.updates[0].error.message : '';
                            this.alertModalService.createAlertMessage('Error updating angles features.' + errorMessage, 'Ok');
                        }
                    },
                    error: err => {
                        this.alertModalService.createAlertMessage('Error updating angle features. Error : ' + err, 'Ok');
                    }
                });
        }
    }

    recreateEnlargements(
        newAttributes,
        polygon,
        enlargementFeature,
        scale,
        fourPerPage,
        flag,
        updateEnlargementCallback?,
        ignoreMapUpdate?
    ): Observable<void> {
        const annotationsExisting = [];
        const annotationsEnlargement = [];
        const anglesExisting = [];
        const anglesEnlargement = [];

        let refScaleItem;
        if (scale.referenceScale) {
            const referenceScaleTokens = scale.referenceScale.split(':');
            refScaleItem = parseInt(referenceScaleTokens.length > 1 ? referenceScaleTokens[1] : referenceScaleTokens[0]);
        } else {
            refScaleItem = scale;
        }

        const mainMapScaleRatio = refScaleItem / this.printAreaService.getReferenceScaleDivisor();
        return new Observable<void>(observer => {
            this.enlargementUtilService.findRelatedFeatures(
                this.spatialUtilService.getAnnotationMapLayer(),
                polygon.getExtent(),
                enlargementFeature,
                [
                    this.spatialUtilService.getLineMapLayer(),
                    this.spatialUtilService.getPolylineMapLayer(),
                    this.spatialUtilService.getPolygonMapLayer(),
                    this.spatialUtilService.getLotMapLayer(),
                    this.spatialUtilService.getInterestMapLayer(),
                    this.spatialUtilService.getConstructLineMapLayer()
                ],
                annotationsExisting,
                annotationsEnlargement,
                () => {
                    this.enlargementUtilService.findAllAnnotationsWithinPolygon(polygon, annotationsExisting, annotationsEnlargement, () => {
                        this.enlargementUtilService.findAllAnnotationsWithinEnlargementPolygon(
                            polygon,
                            annotationsExisting,
                            annotationsEnlargement,
                            enlargementFeature.attributes.id,
                            () => {
                                this.enlargementUtilService.findAllAnglesForEnlargementUpdate(
                                    polygon,
                                    anglesExisting,
                                    anglesEnlargement,
                                    enlargementFeature.attributes.id,
                                    this.printAreaService.getReferenceScaleDivisor(),
                                    enlargementFeature.attributes.scale,
                                    refScaleItem
                                );

                                const lineTypeLookups = this.getInterestPolylineTotalLotBoundaryLineTypeLookups();

                                if (flag) {
                                    const annotationsBeforeChange = this.spatialUtilService.getAnnotations().filter(
                                        a =>
                                            a.attributes &&
                                            a.attributes.featuretype !== 'enlargement' &&
                                            // filter out the annotation for the enlargement feature
                                            a.attributes.enlargementid === enlargementFeature.attributes.id
                                    );

                                    const anglesBeforeChange = this.spatialUtilService
                                        .getAngles()
                                        .filter(f => f.attributes.enlargementid === enlargementFeature.attributes.id);

                                    this.applyEnlargementRecreation(
                                        enlargementFeature,
                                        annotationsEnlargement,
                                        annotationsExisting,
                                        anglesEnlargement,
                                        anglesExisting,
                                        refScaleItem,
                                        lineTypeLookups,
                                        annotationsBeforeChange,
                                        anglesBeforeChange,
                                        ignoreMapUpdate
                                    );

                                    enlargementFeature.geometry = polygon;
                                    enlargementFeature.attributes.scale = refScaleItem;
                                    enlargementFeature.attributes.fullpage = newAttributes.fullpage.description || newAttributes.fullpage;
                                    enlargementFeature.attributes.pageorder = null;
                                    enlargementFeature.attributes.itemorder = null;

                                    this.enlargementUtilService.updateEnlargementFeature(enlargementFeature, updateEnlargementCallback || of());
                                } else {
                                    const enlargementId = enlargementFeature.attributes.id;
                                    const annotationsBeforeChange = this.spatialUtilService
                                        .getAnnotations()
                                        .filter(f => f.attributes.enlargementid === enlargementId);

                                    const anglesBeforeChange = this.spatialUtilService
                                        .getAngles()
                                        .filter(f => f.attributes.enlargementid === enlargementId);

                                    this.applyEnlargementRecreation(
                                        enlargementFeature,
                                        annotationsEnlargement,
                                        annotationsExisting,
                                        anglesEnlargement,
                                        anglesExisting,
                                        refScaleItem,
                                        lineTypeLookups,
                                        annotationsBeforeChange,
                                        anglesBeforeChange,
                                        ignoreMapUpdate
                                    );

                                    enlargementFeature.geometry = polygon;
                                    enlargementFeature.attributes.scale = refScaleItem;
                                    enlargementFeature.attributes.fullpage = newAttributes.fullpage.description || newAttributes.fullpage;
                                    enlargementFeature.attributes.pageorder = null;
                                    enlargementFeature.attributes.itemorder = null;

                                    this.enlargementUtilService.updateEnlargementFeature(enlargementFeature, updateEnlargementCallback || of());
                                }
                                observer.next();
                                observer.complete();
                            }
                        );
                    });
                }
            );
        });
    }

    createFeatures(enlargementId, sequence, layer, data, refScale, scaleRatio) {
        const filteredData = data.filter(f => f && (!f.attributes.enlargementid || f.attributes.enlargementid === enlargementId));

        const legalParcelTypeLookups = this.lookupService.getLookups('legalParcelType');
        const roadLegalParcelTypeLookup = legalParcelTypeLookups.find(l => l.description === 'Road');
        const roadWideningLegalParcelTypeLookup = legalParcelTypeLookups.find(l => l.description === 'Road Widening');

        const featuresForCreation = [];
        const lotsOrRoads = [];

        filteredData.forEach(feature => {
            const isLotOrRoadSubtype =
                feature.attributes.featuresubtype === roadLegalParcelTypeLookup.id ||
                feature.attributes.featuresubtype === roadWideningLegalParcelTypeLookup.id;

            if (
                (feature.attributes.featuretype === 'lot' || feature.attributes.featuretype === 'road') &&
                isLotOrRoadSubtype === true &&
                !lotsOrRoads.find(f => f.attributes.id === feature.attributes.id)
            ) {
                lotsOrRoads.push(feature);
            } else {
                featuresForCreation.push(feature);
            }
        });

        if (featuresForCreation.length) {
            const lineTypeLookups = this.getInterestPolylineTotalLotBoundaryLineTypeLookups();

            featuresForCreation.forEach((feature, index) => {
                feature.attributes.enlargementid = enlargementId;
                feature.attributes.id = sequence[index];

                this.adjustFeature(layer, feature, refScale, lineTypeLookups, scaleRatio);
            });

            this.featuresApplyInsertService
                .insertFeaturesByType(layer, featuresForCreation, createdFeatures => {
                    if (createdFeatures && createdFeatures.length > 0) {
                        console.debug('Enlargement features have been successfully created!');
                    } else {
                        console.debug('Error creating enlargement features!');
                        this.alertModalService.createAlertMessage('Error occurred creating enlargement features.');
                    }
                })
                .subscribe();
        }

        if (lotsOrRoads.length) {
            let count = featuresForCreation.length;

            lotsOrRoads.forEach(feature => {
                feature.attributes.enlargementid = enlargementId;
                feature.attributes.id = sequence[count++];
            });

            this.featuresAdjustmentUtilService.adjustLotOrRoadFeatures(lotsOrRoads, refScale, scaleRatio).subscribe();
        }
    }

    addSelectedAngles(array1, array2) {
        this.spatialUtilService
            .getHighlightedAngles()
            .forEach(a => this.enlargementUtilService.copyAnnotations(array1, array2, a, this.annotationUtilService.getAnnotationSetId({}, a)));
    }

    addSelectedAnnotations(array1, array2) {
        const guidMap = {};

        this.spatialUtilService
            .getHighlightedAnnotations()
            .forEach(a => this.enlargementUtilService.copyAnnotations(array1, array2, a, this.annotationUtilService.getAnnotationSetId(guidMap, a)));

        const lineFeatures = this.spatialUtilService.getHighlightedLines();

        this.spatialUtilService
            .getAnnotations()
            .filter(
                a =>
                    a.attributes.featuretype === 'line' &&
                    a.attributes.featureid &&
                    lineFeatures.some(l => l.attributes.frompointid && l.attributes.id === a.attributes.featureid)
            )
            .forEach(a => this.enlargementUtilService.copyAnnotations(array1, array2, a, this.annotationUtilService.getAnnotationSetId(guidMap, a)));

        const lotFeatures = this.spatialUtilService.getHighlightedLots();

        this.spatialUtilService
            .getAnnotations()
            .filter(
                a =>
                    a.attributes.featuretype === 'lot' &&
                    a.attributes.featureid &&
                    lotFeatures.some(l => l.attributes.polygonids && l.attributes.id === a.attributes.featureid)
            )
            .forEach(a => this.enlargementUtilService.copyAnnotations(array1, array2, a, this.annotationUtilService.getAnnotationSetId(guidMap, a)));

        const interestFeatures = this.spatialUtilService.getHighlightedInterests();

        this.spatialUtilService
            .getAnnotations()
            .filter(
                a =>
                    a.attributes.featuretype === 'interest' &&
                    a.attributes.featureid &&
                    interestFeatures.some(v => v.attributes.interestid && v.attributes.id === a.attributes.featureid)
            )
            .forEach(a => this.enlargementUtilService.copyAnnotations(array1, array2, a, this.annotationUtilService.getAnnotationSetId(guidMap, a)));
    }

    createEnlargementFeature(polygonGraphic, callback) {
        this.featuresApplyInsertService
            .insertFeaturesByType(this.spatialUtilService.getEnlargementMapLayer(), [polygonGraphic], createdPolygons => {
                if (createdPolygons && createdPolygons.length > 0) {
                    console.debug('Enlargement polygon has been successfully created!');

                    this.eventBus.cast('addEnlargementOnMapModeList', createdPolygons[0]);

                    if (callback) {
                        callback(createdPolygons[0]);
                    }
                } else {
                    console.debug('Error creating enlargement polygon!');
                    this.alertModalService.createAlertMessage('Error occurred creating enlargement polygon feature.');
                    if (callback) {
                        callback(undefined);
                    }
                }
            })
            .subscribe();
    }

    adjustFeature(layer, feature, refScale, lineTypeLookups, scaleRatio) {
        const featureLayerType = this.spatialUtilService.getFeatureLayerName(layer);

        if (featureLayerType === 'angle') {
            const offsetLookup = this.lookupService
                .getLookups('featureOffsetSettings')
                .find(lookup => lookup.validCoordSystemIds.includes(this.planModelService.getCoordinateSystem().id));

            const offsetFactor = refScale * offsetLookup.angleOffset;
            const pointFeature = this.mapService.findFeatureByTypeAndId(this.spatialUtilService.getPointMapLayer(), feature.attributes.pointid);

            if (pointFeature) {
                const pointGeometry = pointFeature.geometry;

                const angleRotationRadians = (this.angleUtilService.dmsToDd(feature.attributes.anglerotationdms) * Math.PI) / 180;

                const offsetX = (offsetFactor * Math.sin(angleRotationRadians) * Math.pow(10, 6)) / Math.pow(10, 6);
                const offsetY = (offsetFactor * Math.cos(angleRotationRadians) * Math.pow(10, 6)) / Math.pow(10, 6);

                feature.geometry.x = parseFloat(pointGeometry.x) + offsetX;
                feature.geometry.y = parseFloat(pointGeometry.y) + offsetY;
                feature.attributes.x = feature.geometry.x;
                feature.attributes.y = feature.geometry.y;
            }
        }

        switch (feature.attributes.featuretype) {
            case 'line':
                {
                    const lineFeature = this.mapService.findFeatureByTypeAndId(
                        this.spatialUtilService.getLineMapLayer(),
                        feature.attributes.featureid
                    );
                    if (lineFeature) {
                        const adjustedFeature = this.featuresAdjustmentService.getAdjustedLineFeature(feature, lineFeature.geometry, scaleRatio);
                        if (adjustedFeature) {
                            feature = adjustedFeature;
                        }
                    }
                }
                break;
            case 'constructLine':
                {
                    const constructLineFeature = this.mapService.findFeatureByTypeAndId(
                        this.spatialUtilService.getConstructLineMapLayer(),
                        feature.attributes.featureid
                    );
                    if (constructLineFeature) {
                        const adjustedFeature = this.featuresAdjustmentService.getAdjustedLineFeature(
                            feature,
                            constructLineFeature.geometry,
                            scaleRatio
                        );

                        if (adjustedFeature) {
                            feature = adjustedFeature;
                        }
                    }
                }
                break;
            case 'point':
                {
                    const pointFeature = this.mapService.findFeatureByTypeAndId(
                        this.spatialUtilService.getPointMapLayer(),
                        feature.attributes.featureid
                    );
                    if (pointFeature) {
                        const adjustedFeature = this.featuresAdjustmentService.getAdjustedPointFeature(feature, pointFeature.geometry, scaleRatio);

                        if (adjustedFeature) {
                            feature = adjustedFeature;
                        }
                    }
                }
                break;
            case 'constructPoint':
                {
                    const constructPointFeature = this.mapService.findFeatureByTypeAndId(
                        this.spatialUtilService.getConstructPointMapLayer(),
                        feature.attributes.featureid
                    );
                    if (constructPointFeature) {
                        const adjustedFeature = this.featuresAdjustmentService.getAdjustedPointFeature(
                            feature,
                            constructPointFeature.geometry,
                            scaleRatio
                        );

                        if (adjustedFeature) {
                            feature = adjustedFeature;
                        }
                    }
                }
                break;
            case 'interest':
                if (feature.attributes.childtype === 'polyline') {
                    const polylineFeature = this.mapService.findFeatureByTypeAndId(
                        this.spatialUtilService.getPolylineMapLayer(),
                        feature.attributes.childid
                    );
                    if (polylineFeature) {
                        const adjustedFeature = this.featuresAdjustmentService.getAdjustedLineFeature(feature, polylineFeature.geometry, scaleRatio);
                        if (adjustedFeature) {
                            feature = adjustedFeature;
                        }
                    }
                }

                break;
        }

        return feature;
    }

    updateFeatures(layer, data, callback) {
        if (data && data.length > 0) {
            this.featuresApplyUpdateService
                .updateFeaturesByType(layer, data, () => {})
                .subscribe({
                    next: updatedFeatures => {
                        if (updatedFeatures && updatedFeatures.length > 0) {
                            console.debug(this.title + ' : updateFeatures - Features have been successfully updated!');
                            callback();
                        } else {
                            console.debug(this.title + ' : updateFeatures - Error updating features');
                            callback();
                        }
                    },
                    error: () => {
                        console.debug(this.title + ' : updateFeatures - Error updating features');
                        callback();
                    }
                });
        }
    }
}
